import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as backgroundColor from '../../config/backgroundColor';
import * as color from '../../config/colors';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonService } from '../../service/common.service';
import { DoubleYaxisBarService } from './double-yaxis-bar.service';
import { ECharts } from 'echarts';
import { initOpts } from '../../config/initOpts';
import { legendPosition, axisLabelRotate } from './double-yaxis-bar-interface'
import { ChartResizeService } from '../../service/chart-resize.service';
import { ChartDarkModeService } from '../../service/chart-dark-mode.service';

@Component({
  selector: 'bcac-double-yaxis-bar',
  templateUrl: './double-yaxis-bar.component.html',
  styleUrls: ['./double-yaxis-bar.component.scss']
})
export class DoubleYaxisBarComponent implements OnInit {

  constructor(
    private doubleYaxisBarService: DoubleYaxisBarService,
    private commonService: CommonService,
    private chartResizeService: ChartResizeService,
    private chartDarkModeService: ChartDarkModeService
  ) { }

  chartOption: any = this.doubleYaxisBarService.getColumnChartDefaultOption();

  initOpts;
  ngOnInit() {
    this.initOpts = initOpts;
    fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
      this.chartResizeService.autoResizeAdapt(this.chartInstance, this.chartOption)
    })
    this.updateOption();
  }

  public _bcacChartTitle: { show: boolean, label: string } = {
    show: true,
    label: "图表标题"
  };
  _chartTitleColor = ''
  // 是否显示标题
  @Input()
  set bcacChartShowTitle(show: boolean) {
    this._bcacChartTitle.show = show;
  }

  @Input()
  set bcacChartTitleText(text: string) {
    this._bcacChartTitle.label = text;
    this._bcacChartFileName = text;
  }
  // 图文件名
  public _bcacChartFileName: string = "图表";
  @Input()
  set bcacChartFileName(fileName: string) {
    this._bcacChartFileName = fileName;
  }
  get bcacChartFileName() {
    return this._bcacChartFileName;
  }
  // 是否显示toolbox
  @Input()
  set bcacChartShowToolbox(show: boolean) {
    // this.doubleYaxisBarService.changeToolboxShow(this.chartOption, show)
  }

  _selectList: { value: string | number, optList: { label: string, value: any }[] }[] = [];

  // 数据选择区域
  @Input()
  set bcacSelectList(selectList: any) {
    if (Array.isArray(selectList)) {
      if (selectList.length > 0 && (selectList[0].hasOwnProperty('value') && selectList[0].hasOwnProperty('optList'))) {
        this._selectList = selectList;
      } else {
        selectList = [];
        this._selectList = selectList;
      }
    } else {
      selectList = []
      this._selectList = selectList;
    }
  }

  public _bcacLegendPosition: legendPosition = 'bottom';
  @Input()
  set bcacLegendPosition(position: legendPosition) {
    this._bcacLegendPosition = position;

    this.doubleYaxisBarService.changeLegendPosition(this.chartOption, position);
    this.updateOption()
  };


  isNotSingleData: boolean;

  bcacData: any = null;
  legendDataArr: any[] = [];
  // 图数据
  @Input()
  set bcacChartData(bcacData) {
    this.isNotSingleData = false;
    let legendDataArr = [];
    if (bcacData && bcacData.hasOwnProperty('seriesName')) {
      bcacData.seriesName.forEach(e => {
        legendDataArr.push({
          label: e,
          value: e,
          checked: true
        })
      })
      this.legendDataArr = legendDataArr;
      this.doubleYaxisBarService.changeChartData(this.chartOption, bcacData);
      this.updateOption();
    }
  }

   // 加载等待
   _bcacChartLoading: boolean = false;
   @Input()
   set bcacChartLoading(loading: boolean) {
     this._bcacChartLoading = loading;
   }

  // 输入tooltip的单位
  @Input()
  set bcacTooltipUnit(tooltipUnit: string[]) {
    this.doubleYaxisBarService.changeTooltipUnit(this.chartOption, tooltipUnit)
  }

  @Input()
  set bcacYAxisMinInterval(minInterval: number[]) {
    this.doubleYaxisBarService.changeYAxisMinInterval(this.chartOption, minInterval)
  }

  @Input()
  set bcacXAxisName(xAxisName: string) {
    this.doubleYaxisBarService.changeXAxisName(this.chartOption, xAxisName);
    this.updateOption();
  }

  @Input()
  set bcacYAxisName(yAxisName: string[]) {
    this.doubleYaxisBarService.changeYAxisName(this.chartOption, yAxisName);
    this.updateOption();
  }

  // 输入y轴名距离
  @Input()
  set bcacYAxisNameGap(yAxisNameGap: number) {
    this.doubleYaxisBarService.changeYAxisNameGap(this.chartOption, yAxisNameGap);
    this.updateOption();
  }
  // x轴label的旋转 
  @Input()
  set bcacXAxisLabelRotate(xAxisLabelRotate: axisLabelRotate) {
    this.doubleYaxisBarService.changeXAxisLabelRotate(this.chartOption, xAxisLabelRotate);
    this.updateOption();
  }
  // y轴label的旋转
  @Input()
  set bcacYAxisLabelRotate(yAxisLabelRotate: axisLabelRotate) {
    this.doubleYaxisBarService.changeYAxisLabelRotate(this.chartOption, yAxisLabelRotate);
    this.updateOption();
  }

  dataSourceSelectShow: boolean = false; //数据源选择下拉框是否显示
  // 输入数据源下拉框数据
  @Input()
  set bcacDataSourceList(value: any[]) {
    if (Array.isArray(value) && value.length > 0) {
      this._selectList = value;
      this.dataSourceSelectShow = true;
    } else {
      this.dataSourceSelectShow = false;
    }
  }

  singleSelectIconShow: boolean = false;  // interval选择按钮是否显示
  intervalData: any[] = []; //interval数据
  // 输入interval数据
  @Input()
  set bcacIntervalData(value: any[]) {
    if (Array.isArray(value) && value.length > 0) {
      this.intervalData = value;
      this.singleSelectIconShow = true;
      if (value.length == 1) {
        this.axisScaleChange(value[0].value)
        this.singleSelectIconShow = false;
      }
    } else {
      this.singleSelectIconShow = false;
    }
  }

  isSmallMode: boolean = false;
  @Input()
  set bcacSmallMode(smallMode: boolean) {
    if (smallMode) {
      this.isSmallMode = true;
      this.changeCardPadding(smallMode);
      this.chartResizeService.openSmallMode(this.chartOption, this.isSmallMode, this._bcacLegendPosition)
      this.updateOption();
    } else {
      this.isSmallMode = false;
    }
  }

  @Input()
  set bcacAxisSplitLine(splitLineShow: boolean) {
    if (splitLineShow == true) {
      this.chartResizeService.configSplitLine(true, this.chartOption)
    } else {
      this.chartResizeService.configSplitLine(false, this.chartOption)
    }
  }


  @Input()
  set bcacDarkMode(darkMode: boolean | string) {
    this.changeChartTitleColor(darkMode);
    this.changeCardBackgroundColor(darkMode);
    this.chartDarkModeService.openDarkMode(this.chartOption, darkMode)
  }

  @Input()
  set bcacColors(chartColors: string[]) {
    if (Array.isArray(chartColors)) {
      this.commonService.changeChartColors(this.chartOption, chartColors)
    }
  }


  @Input()
  set bcacSimplifyYAxis(isSimplifyYAxis: boolean) {
    if (isSimplifyYAxis == true) {
      this.doubleYaxisBarService.openSimplifyYAxis(this.chartOption);
    }
  }

  @Input()
  set bcacYAxisMin(yAxisMin: number[]) {
    this.doubleYaxisBarService.setYAxisMin(this.chartOption, yAxisMin);
  }

  @Input()
  set bcacYAxisMax(yAxisMax: number[]) {
    this.doubleYaxisBarService.setYAxisMax(this.chartOption, yAxisMax);
  }

  @Input()
  set bcacYAxisInterval(yAxisInterval: number[]) {
    this.doubleYaxisBarService.setYAxisInterval(this.chartOption, yAxisInterval)
  }

  @Output() bcacGetInstance: EventEmitter<ECharts> = new EventEmitter<ECharts>();

  @Output() bcacDataSourceSelectEmit: EventEmitter<any[]> = new EventEmitter<any[]>();
  chartInstance: ECharts;
  onOptionInit(ec) {
    this.chartInstance = ec;
    this.bcacGetInstance.emit(ec);
  }

  updateOption() {
    if (this.chartInstance) {
      this.chartInstance.setOption(this.chartOption, true)
    }
  }

  _cardPadding = '1rem';
  // 设置卡片的padding
  setCardPadding(cardPadding) {
    switch (cardPadding) {
      case 'none':
        this._cardPadding = '0rem';
        break;
      default:
        this._cardPadding = '1rem';
        break;
    }
  }

  changeCardPadding(smallMode: boolean) {
    if (smallMode) {
      this._cardPadding = '0rem';
    } else {
      this._cardPadding = '1rem';
    }
  }

  changeChartTitleColor(darkMode: boolean | string) {
    if (!darkMode) {
      this._chartTitleColor = ''
    } else {
      this._chartTitleColor = color.darkModeTextColor;
    }
  }

  _cardBackgroundColor = "#FFF";
  changeCardBackgroundColor(darkMode: boolean | string) {
    if (typeof (darkMode) === 'string') {
      this._cardBackgroundColor = darkMode;
    } else if (darkMode) {
      this._cardBackgroundColor = backgroundColor.darkModeBGColor;
    }
  }

  setCardBackgroundColor() {
    if (this._cardBackgroundColor) {
      return this._cardBackgroundColor;
    } else {
      return '#FFF';
    }
  }
  // 模式改变
  selectedModelChange($event) {
    this.bcacDataSourceSelectEmit.emit($event);
  }

  // 坐标轴修改间隔
  axisScaleChange(interval: any) {
    this.doubleYaxisBarService.setInterval(this.chartOption, interval);
    this.updateOption();
  }
  // 更改图例
  legendChange($event) {
    this.doubleYaxisBarService.topLegendChange($event, this.chartInstance);
  }

}
